var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3282 2.66577H2.66565C1.92955 2.66577 1.33282 3.2625 1.33282 3.9986V11.9955C1.33282 12.7316 1.92955 13.3284 2.66565 13.3284H13.3282C14.0643 13.3284 14.6611 12.7316 14.6611 11.9955V3.9986C14.6611 3.2625 14.0643 2.66577 13.3282 2.66577Z",
    stroke: "#0A0A0A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6611 4.66479L8.68335 8.46335C8.47761 8.59225 8.23973 8.66061 7.99695 8.66061C7.75416 8.66061 7.51629 8.59225 7.31054 8.46335L1.33282 4.66479",
    stroke: "#0A0A0A",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9939,
    height: 15.9939,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBlack);
export default __webpack_public_path__ + "static/media/mailBlack.43fc42fb724e9705c3446ebf9ada4691.svg";
export { ForwardRef as ReactComponent };